import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMe } from '../hooks';
import { UserRole } from '../types/user.js';

type RoleRouteProps = {
  allowedRoles: UserRole[];
  redirectTo?: string;
};

export default function RoleRoute({ allowedRoles, redirectTo = '/devices' }: RoleRouteProps) {
  const { data: me, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center text-foreground">
        Loading...
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!allowedRoles.includes(me.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
